import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';

export const fetchDesignationCategory = createAsyncThunk(
  'designationCategory/fetchDesignationCategory',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetDesignationCategory();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          code: item.code,
          label: item.name,
          value: item.id,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  designationCategoryList: [],
  loading: false,
  error: '',
};

const designationCategorySlice = createSlice({
  name: 'designationCategory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDesignationCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDesignationCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.designationCategoryList = action.payload;
        state.error = '';
      })
      .addCase(fetchDesignationCategory.rejected, (state, action) => {
        state.loading = false;
        state.designationCategoryList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default designationCategorySlice.reducer;
